
















































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';

import { Product, Company } from '@/store/modules/lib';

@Component
export default class ProductDetailsWidget extends Vue {

  @Prop({ type: Object, default: {} }) protected product!: Product;
  @Prop({ type: Array, default: () => [] }) protected standCompanies!: Company[];
  @Prop({ type: Object }) protected fileSetting!: any;

}

